import styled from "styled-components";
const ErrorText = styled.p`
  color: #fb4eff;
`;

export default ErrorText;